<template>
  <Modal
    elem-id="modal_scanner_force_out_of_order"
    size="small"
    :title="t('Confirmar avanço fora de ordem')"
    :close-label="t('Cancelar')"
    :save-label="t('Forçar')"
    :save-fn="handleConfirm"
    :show="isVisible"
    @close="handleCancel"
    @dismiss="handleCancel"
  >
    <div class="force-modal-content" data-testid="pdv-scanner-force-out-of-order-modal">
      <p>{{ t('Próximo passo esperado: {expectedStep}. Deseja forçar {scannedStep}?', {
        expectedStep: expectedStepLabel,
        scannedStep: scannedStepLabel
      }) }}</p>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Modal from '../../../ui/Modal.vue';
import { eventBus } from '../../../eventBus';
import { log } from '../../../utils/DebugLogger';

interface ForcePayload {
  expected_step?: string;
  scanned_step?: string;
}

const { t } = useI18n();

const isVisible = ref<boolean>(false);
const payload = ref<ForcePayload | null>(null);

const expectedStepLabel = computed<string>(() => payload.value?.expected_step || t('não informado'));
const scannedStepLabel = computed<string>(() => payload.value?.scanned_step || t('este passo'));

const openModal = (data?: ForcePayload): void => {
  log('ForceOutOfOrderModal', 'openModal', 'Opening modal', data);
  payload.value = data || null;
  isVisible.value = true;
};

const resetState = (): void => {
  isVisible.value = false;
  payload.value = null;
};

const handleConfirm = (): void => {
  eventBus.emit('scanner-force.confirmed');
  resetState();
};

const handleCancel = (): void => {
  eventBus.emit('scanner-force.cancelled');
  resetState();
};

onMounted(() => {
  eventBus.on('modal.scanner-force.open', openModal);
});

onBeforeUnmount(() => {
  eventBus.off('modal.scanner-force.open', openModal);
});
</script>

<style scoped>
.force-modal-content {
  min-height: auto;
  display: flex;
  align-items: center;
}

.force-modal-content p {
  margin: 0;
  line-height: 1.6;
}
</style>
